// extracted by mini-css-extract-plugin
export default {"disabled":"disabled---TQIx5","enabled":"enabled---eh4KZ"};